<template>
  <div class="whitespace-no-wrap ds-text-2xs">
    {{text}}
    <i class="ml-1 ds-text-2xs" :class="icon" />
  </div>
</template>

<script>
export default {
  props: {
    text: { type: String, required: true },
    icon: { type: String, required: true }
  },

  data() {
    return {
      showModal: false
    };
  }
};
</script>